import { Api } from '../AApi'

export const API_SYMBOL = new Api(
  { url: 'symbol' },
  {
    uploadIcon: {
      async request(data, progress = undefined) {
        return this.sdk
          .request({
            method: 'post',
            url: `uploadicon`,
            onUploadProgress: (progressEvent) => {
              if (progress !== undefined) {
                if (progressEvent.lengthComputable) {
                  progress(
                    Math.round(
                      (progressEvent.loaded * 100) / progressEvent.total
                    )
                  )
                } else {
                  progress(progressEvent.loaded)
                }
              }
            },
            data,
          })
          .then((res) => res.data)
      },
    },
    getIcon: {
      async request(params) {
        return this.sdk
          .request({
            method: 'get',
            url: `icons`,
            params,
          })
          .then((res) => res.data)
      },
    },
    deleteIcon: {
      async request(id) {
        return this.sdk
          .request({
            method: 'delete',
            url: `icon/` + id,
          })
          .then((res) => res.data)
      },
    },
    updateImage: {
      async request(data, progress = undefined) {
        return this.sdk
          .request({
            method: 'post',
            url: `updateiconimage`,
            onUploadProgress: (progressEvent) => {
              if (progress !== undefined) {
                if (progressEvent.lengthComputable) {
                  progress(
                    Math.round(
                      (progressEvent.loaded * 100) / progressEvent.total
                    )
                  )
                } else {
                  progress(progressEvent.loaded)
                }
              }
            },
            data,
          })
          .then((res) => res.data)
      },
    },
    updateIcon: {
      async request(data, id) {
        return this.sdk
          .request({
            method: 'put',
            url: `updateicon/` + id,
            data
          })
          .then((res) => res.data)
      },
    },
  }
)
